import { Container } from "@mui/material";

import LoadingSpinner from "components/LoadingSpinner";
import TaskTable from "./table/TaskTable";
import useTaskTableWrapper from "./useTaskTableWrapper";
import TaskModal from "./modals/TaskModal";
import PatientModal from "components/pages/transmissions/modal/patient/PatientModal";
import ArchiveModal from "./modals/ArchiveModal";
import TaskTableAction from "./table/TaskTableAction";

const TaskTableWrapper = ({ selectedTab, isLoading }) => {
  const {
    selectedRowIds,
    handleAddTask,
    taskModalOpen,
    handleArchiveTasks,
    archiveModalOpen,
    singleTaskArchive,
    rowSelection,
    setRowSelection,
  } = useTaskTableWrapper();

  return (
    <>
      {isLoading ? (
        <div style={{ padding: "50px 0", textAlign: "center" }}>
          <LoadingSpinner />
        </div>
      ) : (
        <div>
          <Container className="trans-table__process">
            {selectedRowIds?.length > 0 && !singleTaskArchive && (
              <TaskTableAction
                selectedRows={selectedRowIds?.length}
                selectedTab={selectedTab}
                handleArchiveTasks={handleArchiveTasks}
              />
            )}
          </Container>
          <div style={{ position: "relative" }}>
            {taskModalOpen && <TaskModal selectedTab={selectedTab} />}
            {archiveModalOpen && (
              <ArchiveModal setRowSelection={setRowSelection} />
            )}
            <TaskTable
              selectedTab={selectedTab}
              rowSelection={rowSelection}
              setRowSelection={setRowSelection}
              handleAddTask={handleAddTask}
            />
            <PatientModal />
          </div>
        </div>
      )}
    </>
  );
};

export default TaskTableWrapper;
